import { useCallback } from 'react'
import { UseFormSetValue, UseFormClearErrors } from 'react-hook-form'
import { SourceWalletTypes } from 'types/move/move'
import { WalletType } from 'types/types'
import { SourcePayWallet } from '../../Pay/types'
import { createSourcePayWallet } from '../utils'

interface UseWalletSelectionProps {
  activeWallets?: WalletType[]
  clearErrors: UseFormClearErrors<any>
  setSourceWalletAtom: (wallet: SourcePayWallet) => void
  setValue: UseFormSetValue<any>
}

export const useWalletSelection = ({
  activeWallets,
  clearErrors,
  setSourceWalletAtom,
  setValue,
}: UseWalletSelectionProps) => {
  const handleWalletOnChange = useCallback(
    (walletId: string) => {
      if (!walletId || !activeWallets?.length) return

      clearErrors('sourceWalletLsid')
      const selectedWallet = activeWallets.find(wallet => wallet?.lsid === walletId)

      if (selectedWallet) {
        const sourceWallet = createSourcePayWallet(selectedWallet, SourceWalletTypes.MAIN)
        setSourceWalletAtom(sourceWallet)
        setValue('sourceWalletLsid', walletId)
      }
    },
    [activeWallets, clearErrors, setSourceWalletAtom, setValue]
  )

  return { handleWalletOnChange }
}
